import * as Layout from '../layouts';
import * as Pages from '../config/pagesConfig';
import { routesName } from '../constants/routes-name';

export const appRoutes = [
  {
    Component: Layout.LandingPageLayout,
    children: {
      Component: Layout.AuthLayout,
      children: [
        {
          path: routesName.login,
          Component: Pages.LoginPage,
        },
        {
          path: routesName.signupBuyer,
          Component: Pages.SignupPage,
        },
        {
          path: routesName.forgotPassword,
          Component: Pages.ForgotPassword,
        },
        {
          path: routesName.resetPassword,
          Component: Pages.ResetPassword,
        },
      ],
    },
  },
  {
    Component: Layout.LandingPageLayout,
    children: [
      {
        path: routesName.home,
        Component: Pages.LandingPage,
      },
      {
        path: routesName.about,
        Component: Pages.AboutPage,
      },
      {
        path: routesName.tenders,
        Component: Pages.HomeTendersPage,
      },
      {
        path: routesName.my_tenders,
        Component: Pages.HomeTendersPage,
      },
      {
        path: routesName.contact,
        Component: Pages.ContactPage,
      },
      {
        path: routesName.ngounStaff,
        Component: Pages.NgounStaff,
      },
      {
        path: routesName.termsAndConditions,
        Component: Pages.TermsAndConditions,
      },
      {
        path: routesName.pricing,
        Component: Pages.PricingPage,
      },
      {
        path: routesName[`404`],
        Component: Pages.LandingPage,
      },
    ],
  },
  {
    Component: Layout.LandingPageLayout,
    children: {
      Component: Layout.DashboardLayout,
      children: [
        {
          path: routesName.chats,
          Component: Pages.ChatsListing,
        },
        {
          path: routesName.openChat,
          Component: Pages.ChatsDetail,
        },
        {
          path: routesName.unreadMessages,
          Component: Pages.UnreadMessages,
        },
        {
          path: routesName.downloadBid,
          Component: Pages.DownloadBids,
        },
        {
          path: routesName.tenderListing,
          Component: Pages.TenderListing,
        },
        {
          path: routesName.myTenderListing,
          Component: Pages.MyTenderListing,
        },
        {
          path: routesName.createTender,
          Component: Pages.AddTender,
        },
        {
          path: routesName.editTender,
          Component: Pages.AddTender,
        },
        {
          path: routesName.viewTender,
          Component: Pages.TenderDetail,
        },
        {
          path: routesName.dashboard,
          Component: Pages.DashboardPages,
        },
      ],
    },
  },
];
